import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-display-messages',
  templateUrl: './display-messages.component.html',
  styleUrls: ['./display-messages.component.css']
})
export class DisplayMessagesComponent implements OnInit {
  MessageType:string='';
  
  constructor() { }

  ngOnInit() {
  }

}
